// reset Email Take

import { sendPasswordResetEmail } from "firebase/auth";
import { motion } from "framer-motion";
import React, { useState } from "react";
import { ColorRing } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert";
import { auth } from "../../config/firebase";
import { setMessage } from "../../redux/message";
import Layout from "../../components/Layout";
import { Dark_White_mode } from "../../utils/constants";
import { CButton, CookEInput } from "../../components/CommonComponents";

const initialState = {
  email: "",
};

function ResetPassword() {
  const [values, setValues] = useState(initialState);
  const [visible, setIsVisible] = useState(false);
  const { message } = useSelector((state) => state.message);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetPassword = async (email) => {
    setIsVisible(true);

    try {
      await sendPasswordResetEmail(auth, email);
      Swal({
        icon: "success",
        title: "reset link has been sent to your email inbox",
        showConfirmButton: true,
        confirmButtonColor: "#f35d34",
      });
      navigate("/signin");
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        dispatch(setMessage("User not found"));
      } else {
        dispatch(setMessage(error.message));
      }
    }
    setIsVisible(false);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const { email } = values;
    resetPassword(email);
  };

  return (
    <Layout variant="auth" setHeight={false}>
      <div className="">
        <div className="max-w-3xl mx-auto text-center pb-8">
          <h1 className={`${Dark_White_mode} text-3xl font-bold mb-4`}>Forgot your password?</h1>
          <p className={`${Dark_White_mode} text-md`}>
            Enter your email and we'll send you a reset link
          </p>
        </div>

        <form onSubmit={onSubmit}>
          <div className="flex flex-wrap -mx-3 mb-4">
            <div className="w-full px-3">
              <CookEInput
                type="email"
                name="email"
                value={values.email}
                onChange={handleChange}
                className="form-input w-full"
                placeholder="you@email.com"
                required
                label="Email"
              />
            </div>
          </div>

          {message && (
            <p className={`mt-2 mx-3 text-md font-bold text-center ${Dark_White_mode}`}>
              <div className="text-red-600 h-full" role="alert">
                {message}
              </div>
            </p>
          )}

          <div className="flex flex-wrap mt-4">
            <CButton type="submit" className="w-full">
              Send reset link
            </CButton>
          </div>

          {visible && (
            <div className="z-50 absolute top-[50%] left-[50%] -translate-x-[50%]">
              <ColorRing
                visible={true}
                height="100"
                width="100"
                ariaLabel="blocks-loading"
                wrapperStyle={{}}
                wrapperClass="blocks-wrapper"
                colors={["#e15b64", "#f47e60", "#f8b26a", "#abbd81", "#849b87"]}
              />
            </div>
          )}
        </form>

        <div className={`${Dark_White_mode} text-center mt-2`}>
          <Link
            to="/signin"
            className="text-orange-400 hover:underline transition duration-150 ease-in-out"
          >
            Back to Login
          </Link>
        </div>
      </div>
    </Layout>
  );
}

export default ResetPassword;
